export default "__VITE_ASSET__fc7f0288__"